webpackJsonp([2],{

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * arfolyam service az árfolyamok lekérdezéshez tartozó servie
 * @author Koppany Kiss 2017.05.17.
 */
var MODULE_NAME = 'contactService';

var ContactService = function () {
	ContactService.$inject = ['$http'];

	function ContactService($http) {
		'ngInject';

		_classCallCheck(this, ContactService);

		this.$http = $http;
		this.apiRoot = '/api/';
	}

	ContactService.prototype.sendEmail = function sendEmail(emailObject) {
		var objectToPost = Object.assign({}, emailObject);
		var captchaValue = objectToPost.captchaValue;
		delete objectToPost.captchaValue;
		return this.$http({
			url: this.apiRoot + 'kapcsolat/vallalati/',
			method: 'POST',
			headers: {
				'captcha': captchaValue
			},
			data: objectToPost
		});
	};

	ContactService.prototype.getVallalatiInit = function getVallalatiInit() {
		return this.$http.get(this.apiRoot + 'kapcsolat/vallalati/init');
	};

	ContactService.prototype.getKapcsolatInit = function getKapcsolatInit() {
		return this.$http.get(this.apiRoot + 'kapcsolat/init');
	};

	ContactService.prototype.sendKapcsolatEmail = function sendKapcsolatEmail(emailObject) {
		var objectToPost = Object.assign({}, emailObject);
		var captchaValue = objectToPost.captchaValue;
		delete objectToPost.captchaValue;
		return this.$http({
			url: this.apiRoot + 'kapcsolat/',
			method: 'POST',
			headers: {
				'captcha': captchaValue
			},
			data: objectToPost
		});
	};

	return ContactService;
}();

/* harmony default export */ __webpack_exports__["a"] = (angular.module(MODULE_NAME, []).service('contactService', ContactService).name);

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_contact_service__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vallalati_kapcsolat_pug__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vallalati_kapcsolat_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vallalati_kapcsolat_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vallalati_kapcsolat_form_vallalati_kapcsolat_form__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v1__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid_v1__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Aktuális árfolyamokat lekérdező komponens
 * @author Koppany Kiss 2017.05.17.
 */




var MODULE_NAME = 'vallalatiKapcsolat';

var VallalatiKapcsolatController = function () {
	VallalatiKapcsolatController.$inject = ['contactService', '$rootScope'];

	function VallalatiKapcsolatController(contactService, $rootScope) {
		'ngInject';

		_classCallCheck(this, VallalatiKapcsolatController);

		this.contactService = contactService;
		this.uuid = __WEBPACK_IMPORTED_MODULE_3_uuid_v1___default.a;
		this.rootScope = $rootScope;
	}

	VallalatiKapcsolatController.prototype.$onInit = function $onInit() {
		var _this = this;

		this.contactService.getVallalatiInit().then(function (response) {
			_this.getUuid(function (captchaId) {
				_this.initData = response.data;
				_this.initData.captchaId = captchaId;
			});
		}, function (error) {
			_this.rootScope.$broadcast('serverError');
			_this.error = error;
		});
	};

	VallalatiKapcsolatController.prototype.sendEmail = function sendEmail(model) {
		var _this2 = this;

		this.model = model;
		this.contactService.sendEmail(this.model).then(function (response) {
			if (response.status == 200) {
				_this2.success = true;
			}
		}, function (error) {
			_this2.error = error;
		});
	};

	VallalatiKapcsolatController.prototype.getUuid = function getUuid(callback) {
		callback(this.uuid());
	};

	return VallalatiKapcsolatController;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (angular.module(MODULE_NAME, [__WEBPACK_IMPORTED_MODULE_0__services_contact_service__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__vallalati_kapcsolat_form_vallalati_kapcsolat_form__["a" /* default */]]).component('vallalatiKapcsolat', {
	controller: VallalatiKapcsolatController,
	template: __WEBPACK_IMPORTED_MODULE_1__vallalati_kapcsolat_pug___default()(),
	bindings: {}
}).name);

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(37);
module.exports = 'vcRecaptcha';


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

/**
 * @license angular-recaptcha build:2018-05-09
 * https://github.com/vividcortex/angular-recaptcha
 * Copyright (c) 2018 VividCortex
**/

/*global angular, Recaptcha */
(function (ng) {
    'use strict';

    ng.module('vcRecaptcha', []);

}(angular));

/*global angular */
(function (ng) {
    'use strict';

    function throwNoKeyException() {
        throw new Error('You need to set the "key" attribute to your public reCaptcha key. If you don\'t have a key, please get one from https://www.google.com/recaptcha/admin/create');
    }

    var app = ng.module('vcRecaptcha');

    /**
     * An angular service to wrap the reCaptcha API
     */
    app.provider('vcRecaptchaService', function(){
        var provider = this;
        var config = {};
        provider.onLoadFunctionName = 'vcRecaptchaApiLoaded';

        /**
         * Sets the reCaptcha configuration values which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param defaults  object which overrides the current defaults object.
         */
        provider.setDefaults = function(defaults){
            ng.copy(defaults, config);
        };

        /**
         * Sets the reCaptcha key which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param siteKey  the reCaptcha public key (refer to the README file if you don't know what this is).
         */
        provider.setSiteKey = function(siteKey){
            config.key = siteKey;
        };

        /**
         * Sets the reCaptcha theme which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param theme  The reCaptcha theme.
         */
        provider.setTheme = function(theme){
            config.theme = theme;
        };

        /**
         * Sets the reCaptcha stoken which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param stoken  The reCaptcha stoken.
         */
        provider.setStoken = function(stoken){
            config.stoken = stoken;
        };

        /**
         * Sets the reCaptcha size which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param size  The reCaptcha size.
         */
        provider.setSize = function(size){
            config.size = size;
        };

        /**
         * Sets the reCaptcha type which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param type  The reCaptcha type.
         */
        provider.setType = function(type){
            config.type = type;
        };

        /**
         * Sets the reCaptcha language which will be used by default is not specified in a specific directive instance.
         *
         * @param lang  The reCaptcha language.
         */
        provider.setLang = function(lang){
            config.lang = lang;
        };

        /**
         * Sets the reCaptcha badge position which will be used by default if not specified in a specific directive instance.
         *
         * @param badge  The reCaptcha badge position.
         */
        provider.setBadge = function(badge){
            config.badge = badge;
        };

        /**
         * Sets the reCaptcha configuration values which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param onLoadFunctionName  string name which overrides the name of the onload function. Should match what is in the recaptcha script querystring onload value.
         */
        provider.setOnLoadFunctionName = function(onLoadFunctionName){
            provider.onLoadFunctionName = onLoadFunctionName;
        };

        provider.$get = ['$rootScope','$window', '$q', '$document', '$interval', function ($rootScope, $window, $q, $document, $interval) {
            var deferred = $q.defer(), promise = deferred.promise, instances = {}, recaptcha;

            $window.vcRecaptchaApiLoadedCallback = $window.vcRecaptchaApiLoadedCallback || [];

            var callback = function () {
                recaptcha = $window.grecaptcha;

                deferred.resolve(recaptcha);
            };

            $window.vcRecaptchaApiLoadedCallback.push(callback);

            $window[provider.onLoadFunctionName] = function () {
                $window.vcRecaptchaApiLoadedCallback.forEach(function(callback) {
                    callback();
                });
            };


            function getRecaptcha() {
                if (!!recaptcha) {
                    return $q.when(recaptcha);
                }

                return promise;
            }

            function validateRecaptchaInstance() {
                if (!recaptcha) {
                    throw new Error('reCaptcha has not been loaded yet.');
                }
            }

            function isRenderFunctionAvailable() {
                return ng.isFunction(($window.grecaptcha || {}).render);
            }


            // Check if grecaptcha.render is not defined already.
            if (isRenderFunctionAvailable()) {
                callback();
            } else if ($window.document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]')) {
                // wait for script to be loaded.
                var intervalWait = $interval(function() {
                    if (isRenderFunctionAvailable()) {
                        $interval.cancel(intervalWait);
                        callback();
                    }
                }, 25);
            } else {
                // Generate link on demand
                var script = $window.document.createElement('script');
                script.async = true;
                script.defer = true;
                script.src = 'https://www.google.com/recaptcha/api.js?onload='+provider.onLoadFunctionName+'&render=explicit';
                $document.find('body')[0].appendChild(script);
            }

            return {

                /**
                 * Creates a new reCaptcha object
                 *
                 * @param elm  the DOM element where to put the captcha
                 * @param conf the captcha object configuration
                 * @throws NoKeyException    if no key is provided in the provider config or the directive instance (via attribute)
                 */
                create: function (elm, conf) {

                    conf.sitekey = conf.key || config.key;
                    conf.theme = conf.theme || config.theme;
                    conf.stoken = conf.stoken || config.stoken;
                    conf.size = conf.size || config.size;
                    conf.type = conf.type || config.type;
                    conf.hl = conf.lang || config.lang;
                    conf.badge = conf.badge || config.badge;

                    if (!conf.sitekey) {
                        throwNoKeyException();
                    }
                    return getRecaptcha().then(function (recaptcha) {
                        var widgetId = recaptcha.render(elm, conf);
                        instances[widgetId] = elm;
                        return widgetId;
                    });
                },

                /**
                 * Reloads the reCaptcha
                 */
                reload: function (widgetId) {
                    validateRecaptchaInstance();

                    recaptcha.reset(widgetId);

                    // Let everyone know this widget has been reset.
                    $rootScope.$broadcast('reCaptchaReset', widgetId);
                },

                /**
                 * Executes the reCaptcha
                 */
                execute: function (widgetId) {
                    validateRecaptchaInstance();

                    recaptcha.execute(widgetId);
                },

                /**
                 * Get/Set reCaptcha language
                 */
                useLang: function (widgetId, lang) {
                    var instance = instances[widgetId];

                    if (instance) {
                        var iframe = instance.querySelector('iframe');
                        if (lang) {
                            // Setter
                            if (iframe && iframe.src) {
                                var s = iframe.src;
                                if (/[?&]hl=/.test(s)) {
                                    s = s.replace(/([?&]hl=)\w+/, '$1' + lang);
                                } else {
                                    s += ((s.indexOf('?') === -1) ? '?' : '&') + 'hl=' + lang;
                                }

                                iframe.src = s;
                            }
                        } else {
                            // Getter
                            if (iframe && iframe.src && /[?&]hl=\w+/.test(iframe.src)) {
                                return iframe.src.replace(/.+[?&]hl=(\w+)([^\w].+)?/, '$1');
                            } else {
                                return null;
                            }
                        }
                    } else {
                        throw new Error('reCaptcha Widget ID not exists', widgetId);
                    }
                },

                /**
                 * Gets the response from the reCaptcha widget.
                 *
                 * @see https://developers.google.com/recaptcha/docs/display#js_api
                 *
                 * @returns {String}
                 */
                getResponse: function (widgetId) {
                    validateRecaptchaInstance();

                    return recaptcha.getResponse(widgetId);
                },

                /**
                 * Gets reCaptcha instance and configuration
                 */
                getInstance: function (widgetId) {
                    return instances[widgetId];
                },

                /**
                 * Destroy reCaptcha instance.
                 */
                destroy: function (widgetId) {
                    delete instances[widgetId];
                }
            };

        }];
    });

}(angular));

/*global angular, Recaptcha */
(function (ng) {
    'use strict';

    var app = ng.module('vcRecaptcha');

    app.directive('vcRecaptcha', ['$document', '$timeout', 'vcRecaptchaService', function ($document, $timeout, vcRecaptcha) {

        return {
            restrict: 'A',
            require: "?^^form",
            scope: {
                response: '=?ngModel',
                key: '=?',
                stoken: '=?',
                theme: '=?',
                size: '=?',
                type: '=?',
                lang: '=?',
                badge: '=?',
                tabindex: '=?',
                required: '=?',
                onCreate: '&',
                onSuccess: '&',
                onExpire: '&'
            },
            link: function (scope, elm, attrs, ctrl) {
                scope.widgetId = null;

                if(ctrl && ng.isDefined(attrs.required)){
                    scope.$watch('required', validate);
                }

                var removeCreationListener = scope.$watch('key', function (key) {
                    var callback = function (gRecaptchaResponse) {
                        // Safe $apply
                        $timeout(function () {
                            scope.response = gRecaptchaResponse;
                            validate();

                            // Notify about the response availability
                            scope.onSuccess({response: gRecaptchaResponse, widgetId: scope.widgetId});
                        });
                    };

                    vcRecaptcha.create(elm[0], {

                        callback: callback,
                        key: key,
                        stoken: scope.stoken || attrs.stoken || null,
                        theme: scope.theme || attrs.theme || null,
                        type: scope.type || attrs.type || null,
                        lang: scope.lang || attrs.lang || null,
                        tabindex: scope.tabindex || attrs.tabindex || null,
                        size: scope.size || attrs.size || null,
                        badge: scope.badge || attrs.badge || null,
                        'expired-callback': expired

                    }).then(function (widgetId) {
                        // The widget has been created
                        validate();
                        scope.widgetId = widgetId;
                        scope.onCreate({widgetId: widgetId});

                        scope.$on('$destroy', destroy);

                        scope.$on('reCaptchaReset', function(event, resetWidgetId){
                          if(ng.isUndefined(resetWidgetId) || widgetId === resetWidgetId){
                            scope.response = "";
                            validate();
                          }
                        })

                    });

                    // Remove this listener to avoid creating the widget more than once.
                    removeCreationListener();
                });

                function destroy() {
                  if (ctrl) {
                    // reset the validity of the form if we were removed
                    ctrl.$setValidity('recaptcha', null);
                  }

                  cleanup();
                }

                function expired(){
                    // Safe $apply
                    $timeout(function () {
                        scope.response = "";
                        validate();

                        // Notify about the response availability
                        scope.onExpire({ widgetId: scope.widgetId });
                    });
                }

                function validate(){
                    if(ctrl){
                        ctrl.$setValidity('recaptcha', scope.required === false ? null : Boolean(scope.response));
                    }
                }

                function cleanup(){
                  vcRecaptcha.destroy(scope.widgetId);

                  // removes elements reCaptcha added.
                  ng.element($document[0].querySelectorAll('.pls-container')).parent().remove();
                }
            }
        };
    }]);

}(angular));


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(60);
var bytesToUuid = __webpack_require__(59);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vallalati_kapcsolat_vallalati_kapcsolat_form_vallalati_kapcsolat_form_pcss__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vallalati_kapcsolat_vallalati_kapcsolat_form_vallalati_kapcsolat_form_pcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vallalati_kapcsolat_vallalati_kapcsolat_form_vallalati_kapcsolat_form_pcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vallalati_kapcsolat_vallalati_kapcsolat_vallalati_kapcsolat_js__ = __webpack_require__(306);



/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vallalati_kapcsolat_form_pug__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vallalati_kapcsolat_form_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vallalati_kapcsolat_form_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_messages__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_messages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular_messages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_refresh_selects__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular_recaptcha__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angular_recaptcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_constants_consts__ = __webpack_require__(32);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Az aktuális árfolyamokat táblázatban megjelenítő komponens
 * @author Koppany Kiss 2017.05.17.
 */






var MODULE_NAME = 'vallalatiKapcsolatForm';

var VallalatiKapcsolatFormController = function (_RefreshSelects) {
	VallalatiKapcsolatFormController.$inject = ['$http', '$rootScope', 'vcRecaptchaService', '$element'];

	_inherits(VallalatiKapcsolatFormController, _RefreshSelects);

	function VallalatiKapcsolatFormController($http, $rootScope, vcRecaptchaService, $element) {
		'ngInject';

		_classCallCheck(this, VallalatiKapcsolatFormController);

		var _this = _possibleConstructorReturn(this, _RefreshSelects.call(this, $element));

		_this.$http = $http;
		_this.rootScope = $rootScope;
		_this.vcRecaptchaService = vcRecaptchaService;

		return _this;
	}

	VallalatiKapcsolatFormController.prototype.$onInit = function $onInit() {
		this.model = {};
		this.patterns = {
			email: __WEBPACK_IMPORTED_MODULE_4__common_constants_consts__["a" /* EMAIL_PATTERN */],
			phone: __WEBPACK_IMPORTED_MODULE_4__common_constants_consts__["b" /* PHONE_PATTERN */],
			simpleText: __WEBPACK_IMPORTED_MODULE_4__common_constants_consts__["c" /* SIMPLE_TEXT_PATTERN */],
			number: __WEBPACK_IMPORTED_MODULE_4__common_constants_consts__["d" /* NUMBER_PATTERN */]
		};
	};

	VallalatiKapcsolatFormController.prototype.$onChanges = function $onChanges(changeObject) {
		var _this2 = this;

		if (changeObject.initData && !changeObject.initData.isFirstChange()) {
			this.restMegye = angular.copy(this.initData.megyek);
			this.restTema = angular.copy(this.initData.targyak);
			this.captchaUrl = angular.copy(this.initData.captchaUrl);
			this.model.captchaId = angular.copy(this.initData.captchaId);
			this.minEmployees = angular.copy(this.initData.minAlkalmazottak);
			this.rerenderNativeSelects();
		}
		if (changeObject.errors && !changeObject.errors.isFirstChange()) {
			this.resetCaptcha();
			this.serverError = angular.copy(this.errors.data.errors);
			this.serverError.forEach(function (item) {
				if (item.field == 'captcha' && item.message == 'invalid') {
					_this2.model.captchaValue = '';
					_this2.kapcsolattartoForm.captcha.$error.serverError = true;
				} else {
					_this2.rootScope.$broadcast('serverError');
				}
			});
		}
	};

	VallalatiKapcsolatFormController.prototype.postContactForm = function postContactForm() {
		if (this.kapcsolattartoForm.$valid) {
			this.postForm({
				emailObject: this.model
			});
		}
	};

	VallalatiKapcsolatFormController.prototype.getCaptcha = function getCaptcha() {
		var now = new Date().getTime();
		this.captchaImage = this.captchaUrl.replace('{id}', this.model.captchaId + '?' + now);
	};

	VallalatiKapcsolatFormController.prototype.resetCaptcha = function resetCaptcha() {
		this.vcRecaptchaService.reload();
	};

	return VallalatiKapcsolatFormController;
}(__WEBPACK_IMPORTED_MODULE_2__common_utils_refresh_selects__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (angular.module(MODULE_NAME, ['ngMessages', __WEBPACK_IMPORTED_MODULE_3_angular_recaptcha___default.a]).component('vallalatiKapcsolatForm', {
	controller: VallalatiKapcsolatFormController,
	template: __WEBPACK_IMPORTED_MODULE_0__vallalati_kapcsolat_form_pug___default()(),
	bindings: {
		initData: '<',
		errors: '<',
		postForm: '&'
	}
}).name);

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__native_accessible_select_native_accessible_select__ = __webpack_require__(53);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var RefreshSelects = function () {
	RefreshSelects.$inject = ['$element'];

	function RefreshSelects($element) {
		'ngInject';

		_classCallCheck(this, RefreshSelects);

		this.rootElementForSelects = $element[0];
	}

	RefreshSelects.prototype.rerenderNativeSelects = function rerenderNativeSelects() {
		var _this = this;

		setTimeout(function () {
			var designSelects = Array.from(_this.rootElementForSelects.querySelectorAll('.accessible-select-wrapper'));
			designSelects.forEach(function (item) {
				item.parentNode.removeChild(item);
			});

			var selects = Array.from(_this.rootElementForSelects.querySelectorAll('select'));
			selects.forEach(function (item) {
				item.removeAttribute('has-accessible-select');
				setTimeout(function () {
					new __WEBPACK_IMPORTED_MODULE_0__native_accessible_select_native_accessible_select__["a" /* default */]({ element: item });
				}, 0);
			});
		}, 0);
	};

	return RefreshSelects;
}();

/* harmony default export */ __webpack_exports__["a"] = (RefreshSelects);

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),

/***/ 60:
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cform class=\"vallalati-kapcsolat-form\" name=\"$ctrl.kapcsolattartoForm\" novalidate\u003E\u003Cdiv class=\"row form__row\" aria-hidden=\"true\"\u003E\u003Cdiv class=\"col-sm-8 col-sm-offset-4\"\u003E\u003Csmall class=\"app-kapcsolat__disclaimer\"\u003E*: Kötelezően kitöltendő mezők\u003C\u002Fsmall\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" id=\"vallalati-kapcsolat-form__megye-label\" for=\"vallalati-kapcsolat-form__megye\"\u003EKérjük válasszon megyét\u003Cspan aria-hidden=\"true\"\u003E*:\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cselect class=\"select\" id=\"vallalati-kapcsolat-form__megye\" name=\"megye\" ng-model=\"$ctrl.model.country\" required\u003E\u003Coption value=\"\" disabled selected role=\"option\"\u003EKérjük válasszon!\u003C\u002Foption\u003E\u003Coption value=\"{{ megye }}\" ng-repeat=\"megye in $ctrl.restMegye track by $index\" role=\"option\"\u003E{{ megye }}\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Cinput-error id=\"countyError\" form=\"$ctrl.kapcsolattartoForm\" input-name=\"megye\" message-required=\"Kérjük válasszon megyét!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"vallalati-kapcsolat-form__nev\"\u003ENév\u003Cspan aria-hidden=\"true\"\u003E*:\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput class=\"form-input\" id=\"vallalati-kapcsolat-form__nev\" type=\"text\" name=\"nev\" ng-model=\"$ctrl.model.name\" maxlength=\"40\" ng-pattern=\"$ctrl.patterns.simpleText\" required aria-describedby=\"nameError\"\u003E\u003Cinput-error id=\"nameError\" form=\"$ctrl.kapcsolattartoForm\" input-name=\"nev\" message-required=\"Kérjük adja meg a nevét!\" message-pattern=\"Kérjük helyesen adja meg a nevét!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"vallalati-kapcsolat-form__cegnev\"\u003ECégnév\u003Cspan aria-hidden=\"true\"\u003E*:\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput class=\"form-input\" id=\"vallalati-kapcsolat-form__cegnev\" type=\"text\" name=\"cegnev\" ng-model=\"$ctrl.model.companyName\" maxlength=\"40\" ng-pattern=\"$ctrl.patterns.simpleText\" required aria-describedby=\"orgError\"\u003E\u003Cinput-error id=\"orgError\" form=\"$ctrl.kapcsolattartoForm\" input-name=\"cegnev\" message-required=\"Kérjük adja meg a cég nevét!\" message-pattern=\"Kérjük helyesen adja meg a cég nevét!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"vallalati-kapcsolat-form__email\"\u003EE-mail cím\u003Cspan aria-hidden=\"true\"\u003E*:\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput class=\"form-input\" id=\"vallalati-kapcsolat-form__email\" type=\"email\" name=\"email\" ng-model=\"$ctrl.model.email\" maxlength=\"40\" ng-pattern=\"$ctrl.patterns.email\" required ng-model-options=\"{updateOn: 'blur'}\" aria-describedby=\"emailError\"\u003E\u003Cinput-error id=\"emailError\" form=\"$ctrl.kapcsolattartoForm\" input-name=\"email\" message-required=\"Kérjük adja meg az e-mail címét!\" message-pattern=\"Hibásan adta meg az e-mail címet, kérjük, pontosítsa az adatokat!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" id=\"vallalati-kapcsolat-form__targy-label\" for=\"vallalati-kapcsolat-form__targy\"\u003ETárgy\u003Cspan aria-hidden=\"true\"\u003E*:\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput-error id=\"subjectError\" form=\"$ctrl.kapcsolattartoForm\" input-name=\"oiTargy\" message-required=\"Kérjük töltse ki a tárgymezőt!\"\u003E\u003C\u002Finput-error\u003E\u003Cselect class=\"select\" id=\"vallalati-kapcsolat-form__targy\" name=\"targy\" ng-model=\"$ctrl.model.subject\" required aria-describedby=\"subjectError\"\u003E\u003Coption value=\"\"\u003EKérjük válasszon!\u003C\u002Foption\u003E\u003Coption value=\"{{ topic }}\" ng-repeat=\"topic in $ctrl.restTema track by $index\"\u003E{{ topic }}\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Cinput-error id=\"subjectError\" form=\"$ctrl.kapcsolattartoForm\" input-name=\"targy\" message-required=\"Kérjük töltse ki a tárgymezőt!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"vallalati-kapcsolat-form__telefon\"\u003ETelefon:\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput class=\"form-input\" id=\"vallalati-kapcsolat-form__telefon\" type=\"tel\" name=\"telefon\" ng-model=\"$ctrl.model.phone\" maxlength=\"25\" ng-pattern=\"$ctrl.patterns.phone\" aria-describedby=\"phoneError\"\u003E\u003Cinput-error id=\"phoneError\" form=\"$ctrl.kapcsolattartoForm\" input-name=\"telefon\" message-pattern=\"Kérjük helyesen adja meg a telefonszámát!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"vallalati-kapcsolat-form__beosztas\"\u003EBeosztás:\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput class=\"form-input\" id=\"vallalati-kapcsolat-form__beosztas\" type=\"text\" name=\"beosztas\" ng-model=\"$ctrl.model.assignment\" maxlength=\"40\" ng-pattern=\"$ctrl.patterns.simpleText\" aria-describedby=\"postError\"\u003E\u003Cinput-error id=\"postError\" form=\"$ctrl.kapcsolattartoForm\" input-name=\"beosztas\" message-pattern=\"Kérjük helyesen adja meg a beosztás mezőt!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"vallalati-kapcsolat-form__alkalmazottakSzama\"\u003EAlkalmazottak száma:\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput class=\"form-input form-input--input-small\" id=\"vallalati-kapcsolat-form__alkalmazottakSzama\" type=\"tel\" name=\"alkalmazottakSzama\" ng-model=\"$ctrl.model.peopleSize\" maxlength=\"6\" ng-pattern=\"$ctrl.patterns.number\" min-employee=\"{{$ctrl.minEmployees}}\"\u003E\u003Cinput-error id=\"employeeError\" form=\"$ctrl.kapcsolattartoForm\" input-name=\"alkalmazottakSzama\" message-required=\"Alkalmazottak száma mező csak számokat tartalmazhat, kérjük, pontosítsa az adatokat!\" message-pattern=\"Kérjük, helyesen adja meg a mező értékét!\" message-min-employee=\"Az ajánlatkérés minimum 50 fős cég esetében lehetséges.\" aria-describedby=\"employeeError\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row captcha__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"captcha\"\u003EEllenőrzés:\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cdiv class=\"captcha\"\u003E\u003Cdiv vc-recaptcha key=\"'6LdfJB8TAAAAAPGueZFYId4-pMm-6RvQ2Tz6ZmyO'\" ng-model=\"$ctrl.model.captchaValue\" name=\"captcha\" required on-expire=\"this.resetCaptcha()\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cinput-error id=\"captchaError\" form=\"$ctrl.kapcsolattartoForm\" input-name=\"captcha\" message-required=\"Hibásan adta meg a képen szereplő szöveget, kérjük, pontosítsa az adatokat!\" message-pattern=\"Kérjük, helyesen adja meg a mező értékét!\" message-server-error=\"Hibásan adta meg a képen szereplő szöveget, kérjük, pontosítsa az adatokat!\"\u003E\u003C\u002Finput-error\u003E\u003Cdiv class=\"checkbox__item\"\u003E\u003Cinput id=\"visszahivas-keres-form__adatvedelmi\" type=\"checkbox\" name=\"adatvedelmi\" ng-model=\"$ctrl.adatvedelmiIsChecked\"\u003E\u003Clabel class=\"checkbox\" for=\"visszahivas-keres-form__adatvedelmi\"\u003EKijelentem, hogy az  \u003Ca href=\"https:\u002F\u002Fwww.otpnyugdij.hu\u002Fstatic\u002Fotpnyugdij\u002Fdownload\u002Fonyp_adatkezelesi_tajekoztato.pdf\" target=\"_blank\" rel=\"noopener noreferrer\"\u003EAdatkezelési tájékoztató\u003C\u002Fa\u003E tartalmát megismertem és tudomásul vettem a tájékoztató III. fejezet 4. pontjában leírt adatkezelést.\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"button\" type=\"submit\" ng-disabled=\"$ctrl.kapcsolattartoForm.$invalid\" ng-click=\"$ctrl.postContactForm()\"\u003EElküld\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"app-vallalati-kapcsolat\"\u003E\u003Cvallalati-kapcsolat-form ng-if=\"!$ctrl.success\" init-data=\"$ctrl.initData\" post-form=\"$ctrl.sendEmail(emailObject)\" errors=\"$ctrl.error\"\u003E\u003C\u002Fvallalati-kapcsolat-form\u003E\u003Cdiv class=\"app-vallalati-kapcsolat__success-wrap\" aria-live=\"assertive\"\u003E\u003Cdiv class=\"app-vallalati-kapcsolat__success\" ng-if=\"$ctrl.success\"\u003E\u003Cp class=\"app-vallalati-kapcsolat__success-text\"\u003EKöszönjük, hogy kapcsolatba lépett velünk!\u003Cbr\u003EMunkatársunk hamarosan felveszi Önnel a kapcsolatot.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ })

},[561]);


// WEBPACK FOOTER //
// application/vallalati-kapcsolat.bundle.js